import { css } from '@emotion/core';
import ClickableContainer from 'components/clickable-container';
import NvIcon from 'shared/components/nv-icon';
import { gray6, white } from 'styles/global_defaults/colors';
import { boldFontWeight, openSansCondensed, textLargeFontSize } from 'styles/global_defaults/fonts';
import { handheld, notDesktop } from 'styles/global_defaults/media-queries';
import { standardSpacing } from 'styles/global_defaults/scaffolding';

type FlyoutHeaderProps ={
  title: string;
  onClose: () => void;
};
const FlyoutHeader = ({ title, onClose }: FlyoutHeaderProps) => {
  const styles = css`
  &.header{
      padding:${standardSpacing}px;
      display:flex;
      justify-content:center;
      border-bottom: 1px solid ${gray6};
      min-height: 60px;
      top:0;
      min-width: 360px;
      ${handheld(css`
      width:100%;
      `)}

      z-index:10;
      background-color:${white};
      .title{
        flex-grow: 1;
        text-align:center;
        font-family: ${openSansCondensed};
        font-size:${textLargeFontSize}px;
        font-weight:${boldFontWeight};
       }
  }
`;
  return (
    <div css={styles} className='header'>
      <div className='title mr-2'>{title}</div>
      <ClickableContainer onClick={onClose} className='close-flyout'>
        <NvIcon size='small' icon='close' />
      </ClickableContainer>
    </div>

  );
};
export default FlyoutHeader;
